import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import { Icon, type IconName } from '~/components/primitives';
import SlideUp from '~/components/utils/SlideUp';
type SortOption = {
  value: string;
  label: string;
  icon: IconName;
};
const MobileSortSlideUp: React.FC<{
  items: readonly SortOption[];
  handleClick: (newSort: string) => void;
  onClose: ComponentProps<typeof SlideUp>['onClose'];
  open: ComponentProps<typeof SlideUp>['open'];
  value: string | null;
}> = props => {
  const $ = _c(8);
  const t0 = props.open;
  const t1 = props.onClose;
  let t2;
  if ($[0] !== props) {
    t2 = props.items.map(option => <li key={option.value}><button type="button" data-testid={`sort-sheet-option-${option.value}`} onClick={() => {
        props.handleClick(option.value);
        props.onClose();
      }} className="group flex w-full flex-row items-center gap-3 rounded-2xl bg-transparent px-3 py-3 text-left transition data-[active=true]:bg-turqoise-100" data-active={option.value === props.value} aria-pressed={option.value === props.value}><Icon name={option.icon} size="sm" className="shrink-0 text-blue-500 transition group-data-[active=true]:text-turqoise" /><span className="min-w-0 flex-1 truncate">{option.label}</span><Icon name="check" size="sm" className="shrink-0 text-turqoise opacity-0 transition group-data-[active=true]:opacity-100" /></button></li>);
    $[0] = props;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <ul className="flex flex-col gap-1 px-6 pb-8 pt-16">{t2}</ul>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props.onClose || $[5] !== props.open || $[6] !== t3) {
    t4 = <SlideUp open={t0} onClose={t1} className="isolate z-30">{t3}</SlideUp>;
    $[4] = props.onClose;
    $[5] = props.open;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default MobileSortSlideUp;